// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".directors-on-call-list{padding:1rem}.directors-on-call-list .v-list-item{padding:0}.directors-on-call-list .v-data-table>.v-data-table__wrapper>table>tbody>tr:hover{background:none!important}", ""]);
// Exports
module.exports = exports;
